import React from 'react'
import { Form } from "react-bootstrap"
import $ from "jquery"
import { Row, Col, Container, Breadcrumb } from 'react-bootstrap';


const CheckboxField = ({ type }) => {
    return (
        <div class="custom-float">
            <label class="form-label form-label" for="validationtelephone">Would you also be interested in a {type === 'sell' ? 'lettings' : 'sales'} valuation?</label>
            <div className="d-flex interest-radio-new">
                <input type="radio" id={type} checked name={type} value="yes" hidden />
                <label class="checkbox-div">No thanks, just {type === 'sell' ? 'sales' : 'lettings'}
                    <input type="radio" id='cradio' name={type === 'sell' ? 'let' : 'sell'} value="no" required />
                    <span class="checkmark"></span>
                </label>

                <label class="checkbox-div">Yes please
                    <input type="radio" id='cradio' name={type === 'sell' ? 'let' : 'sell'} value="yes" />
                    <span class="checkmark"></span>
                </label>

            </div>
            {type === 'sell' ?
            <div className="interest-radio over-60s-valuation">
                <label class="checkbox-div">Over 60? Find out how you could boost your budget by up to 59%
                    <input type="checkbox" id="over-60s" name="oversixty" />
                    <span class="checkmark"></span>
                </label>
            </div> : '' }
        </div>
    )
}

export default CheckboxField